<script lang="ts" setup></script>

<template>
  <div class="w-full flex flex-col-reverse sm:flex-row items-start justify-end gap-y-3 sm:gap-y-0 sm:gap-x-3">
    <slot />
  </div>
</template>
